'use strict';
import {apiUrl} from '../../app/app.api.config';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main', {
    url: '/',
    template: '<main layout="row" layout-align="stretch start" flex ng-if="currentUser"></main>',
    controller: ($scope, $state, Auth, $http, $transitions) => {
      $scope.currentUser = null;
      $http.get(apiUrl().API_URL + '/me')
        .then(data => {
          $scope.currentUser = data.data;
          if($state.is('main')) {
            if($scope.currentUser) {
              $state.transitionTo('main.home');
            } else {
              $state.go('login');
            }
          }

        });
      $transitions.onSuccess({to: 'main'}, () => {
        if($scope.currentUser) {

        } else {
          $state.go('login');
        }
      });
    },
    authenticate: true
  })
  // CLIENTS MODULE
    .state('main.home', {
      url: '^/home',
      template: '<insurance-offers></insurance-offers>',
      authenticate: true,
      module: 'home'
    })
    .state('main.insuranceOffers', {
      url: '^/insuranceOffers',
      template: '<insurance-offers></insurance-offers>',
      authenticate: true,
      module: 'home'
    })
    .state('main.insuranceOrders', {
      url: '^/insuranceOrders/{id:[0-9]{1,8}}',
      component: 'insurances',
      authenticate: true,
      module: 'clients',
      resolve: {
        insuranceOfferId: function($transition$) {
          return $transition$.params('to').id;
        }
      }
    })
    .state('main.insuranceNnwOrders', {
      url: '^/insuranceNnwOrders/{id:[0-9]{1,8}}',
      component: 'insurances',
      authenticate: true,
      module: 'clients',
      resolve: {
        insuranceOfferId: function($transition$) {
          return $transition$.params('to').id;
        }
      }
    })
    .state('main.insuranceDetails', {
      url: '^/insuranceDetails/{id}',
      component: 'insurance',
      authenticate: true,
      module: 'clients',
      resolve: {
        insurancePersonId: function($transition$) {
          return $transition$.params('to').id;
        }
      }
    })
    .state('main.insuranceOtherOrders', {
      url: '^/insuranceOtherOrders/{id:[0-9]{1,8}}',
      component: 'insurancesOther',
      authenticate: true,
      module: 'clients',
      resolve: {
        insuranceOfferId: function($transition$) {
          return $transition$.params('to').id;
        }
      }
    })

    .state('main.insuranceOtherDetails', {
      url: '^/insuranceOtherDetails/{id}',
      component: 'insuranceOther',
      authenticate: true,
      module: 'clients'
    })

    .state('main.insuranceNnwDetails', {
      url: '^/insuranceNnwDetails/{id}',
      component: 'insuranceNnwDetails',
      authenticate: true,
      module: 'clients'
    })


    .state('main.insuranceNnwList', {
      url: '^/insuranceNnwList/{id:[0-9]{1,8}}',
      component: 'insuranceNnwList',
      authenticate: true,
      module: 'clients',
      resolve: {
        insuranceOfferId: function($transition$) {
          return $transition$.params('to').id;
        }
      }
    })

    .state('main.subscribeList', {
      url: '^/subscribeList',
      component: 'subscribeList',
      authenticate: true,
      module: 'clients'
    })

    .state('main.lotosCards', {
      url: '^/lotosCards',
      component: 'lotosCards',
      authenticate: true,
      module: 'clients'
    })

  // .state('main.courseAdd', {
  //   url: '^/course/add',
  //   template: '<course-add></course-add>',
  //   authenticate: true
  // })
  ;
}



// WEBPACK FOOTER //
// ./client/app/main/main.routes.js